import { appSettings } from '@/settings/app-settings';

import createHttpClient from './http-client';

const httpClient = createHttpClient(appSettings.api.ASSET_MANAGER_URL || '');

export async function getContactSuggestions(paylaod: {
  limit?: number;
  offset?: number;
  selectedUserId?: string[];
}) {
  try {
    const response = await httpClient.post('/user-intersection/get-contact-suggestions', paylaod);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function createUserIntersection(paylaod: { contentId: string; targetUserId: string[] }) {
  try {
    const response = await httpClient.post('/user-intersection', paylaod);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getReceivedMessages(params: { limit: number; offset: number }) {
  try {
    const response = await httpClient.get('/user-intersection/received-messages', { params });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getMessageUsers(params: { limit: number; offset: number; switchToBusiness: boolean }) {
  try {
    const response = await httpClient.get('/user-intersection/messages/users', { params });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getUserMessages(params: {
  limit: number;
  offset: number;
  selectedUserId: string;
  switchToBusiness: boolean;
}) {
  try {
    const response = await httpClient.get('/user-intersection/messages', { params });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function createUserIntersectionPortal(body: {
  url: string;
  type: 'PORTAL';
  targetUserId: string[];
}) {
  try {
    const response = await httpClient.post('/user-intersection/portal', body);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function sendMessageUserToBusiness(payload: any) {
  try {
    const response = await httpClient.post('/user-intersection/user-to-business', payload);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function sendMessageBusinessToBusiness(payload: any) {
  try {
    const response = await httpClient.post('/user-intersection/business-to-users', payload);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getUsersAssociatedToBusinessMessage(payload: any) {
  try {
    const response = await httpClient.get('/user-intersection/business/messages/users', { params: payload });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getBusinessToUserMessage(payload: any) {
  try {
    const response = await httpClient.get('/user-intersection/business/messages', { params: payload });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
